<template>
  <div class="md:pb-20 lg:pb-20 relative z-index1">
    <div class="absolute insights-bg z-index--1 md:block lg:block hidden">
      <img
        src="../../../../assets/images/line/insig-line.svg"
        alt="bg-polygon"
        class="h-full w-full"
      />
    </div>
    <div class="absolute insights-bg-mob md:hidden lg:hidden block">
      <img
        src="../../../../assets/images/line/inst-news-bg-mob.svg"
        alt="bg-polygon"
        class="h-full w-full"
      />
    </div>
    <div class="">
      <div class="w-full md:px-0 lg:px-0 px-6 mx-auto md:pt-32 lg:pt-32 pt-6">
        <div class="flex justify-between items-center">
          <p
            class="
              title
              fsize36-16px-isg
              lg:font-normal
              md:font-normal
              font-bold
            "
          >
            Case Studies
          </p>
          <div class="md:block lg:block hidden"></div>
        </div>
        <div class="md:pt-10 lg:pt-10 pt-0">
          <div
            class="
              grid
              md:grid-cols-4
              lg:grid-cols-4
              grid-cols-1
              gap-x-8
              md:gap-y-16
              lg:gap-y-16
            "
          >
            <BlogItem
              v-for="item in pages"
              :key="item._id"
              :item="item"
              category="casestudy"
            />
          </div>
        </div>
        <!-- <div class="flex">
          <base-button
            outline
            type="primary"
            class="
              md:px-10
              lg:px-10
              px-6
              md:py-3
              lg:py-3
              py-1
              fs16700
              border-2
              mx-auto
            "
            >View more</base-button
          >
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import BlogItem from "./BlogItem.vue";
import pageMixin from "@/views/social/admin/pages/blog/mixins/pageMixin";
import { mapState } from "vuex";

export default {
  mixins: [pageMixin],
  components: {
    BlogItem,
  },
  data() {
    return {
      pages: [],
      selectedDis: null,
      selectedUsers: null,
      selectedSeg: null,
      Disease: [
        { value: null, text: "Disease" },
        { value: "a", text: "This is First option" },
        { value: "b", text: "Selected Option" },
        { value: "c", text: "This one is disabled" },
      ],
      Segment: [
        { value: null, text: "Segment" },
        { value: "d", text: "This is First option" },
        { value: "e", text: "Selected Option" },
        { value: "f", text: "This one is disabled" },
      ],
      Users: [
        { value: null, text: "Users" },
        { value: "g", text: "This is First option" },
        { value: "h", text: "Selected Option" },
        { value: "i", text: "This one is disabled" },
      ],
      news: [
        {
          image: require("@/assets/images/child cancer.jpg"),
        },
        {
          image: require("@/assets/images/news2.jpg"),
        },
        {
          image: require("@/assets/images/news3.jpg"),
        },
        {
          image: require("@/assets/images/news4.jpg"),
        },
        {
          image: require("@/assets/images/news5.jpg"),
        },
        {
          image: require("@/assets/images/abtus.jpg"),
        },
        {
          image: require("@/assets/images/hcp-grid2.jpg"),
        },
        {
          image: require("@/assets/images/img8.jpg"),
        },
      ],
    };
  },
  computed: {
    ...mapState("cms", {
      mostread: "mostread",
    }),
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
      this.toggleNavbar();
    },
    async loadData() {
      this.pages = await this.init("casestudy");
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>
